import React from 'react';

const ICON_STROKE = 2.5;

const iconSvgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: ICON_STROKE,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true
};

const VARIANT_ICON = {
  success: (
    <svg {...iconSvgProps}>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  error: (
    <svg {...iconSvgProps}>
      <circle cx="12" cy="12" r="9" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  warning: (
    <svg {...iconSvgProps}>
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <circle cx="12" cy="17" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  ),
  info: (
    <svg {...iconSvgProps}>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <circle cx="12" cy="7.5" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  )
};

const ToastItem = ({ toast, onDismiss }) => {
  const variant = toast.variant || 'info';

  return (
    <div
      className={`hub-toast hub-toast--${variant}${toast.exiting ? ' hub-toast--exiting' : ''}`}
      role="status"
    >
      <span className="hub-toast__icon">{VARIANT_ICON[variant] || VARIANT_ICON.info}</span>
      <p className="hub-toast__message">{toast.message}</p>
      <button
        type="button"
        className="hub-toast__close"
        onClick={onDismiss}
        aria-label="閉じる"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={ICON_STROKE} aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
};

export default ToastItem;
